module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/kq4uKD/tc-custom/9781504094351.jpg?1716663322230",
      "alt": "This image is the cover for the book Detective Samantha Freeman Cases Books One to Three"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Detective Samantha Freeman Cases Books One to Three\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Three heart-pounding crime thrillers in one volume from the author of "), _c('i', [_vm._v("The Accident")]), _vm._v(". ")]), _c('br'), _c('br'), _c('b', [_c('i', [_vm._v("The Shape of Truth")])]), _c('br'), _vm._v(" When Anna learns that her biological father is a member of Parliament who assaulted her mother—and was never held accountable—she’s devastated. She’s determined to bring him to justice. But exposing the truth may bring tragic results . . ."), _c('br'), _c('br'), _c('b', [_c('i', [_vm._v("The Charcoal House")])]), _c('br'), _vm._v(" Emma’s new husband is isolating her from her friends and parents. He takes her paycheck, gaslights her, and forbids her to paint. She manages to complete one picture—of a depressing charcoal house. As shocking revelations about his past emerge, the police and Emma’s loved ones try to free her from a monster’s clutches—but is it already too late to save her?"), _c('br'), _c('br'), _c('b', [_c('i', [_vm._v("The Dead Husband")])]), _c('br'), _vm._v(" At the police station, a woman reports that her husband has disappeared, and soon afterward a body is found. It looks like a hit-and-run case, an accident. But the body is not the missing man’s—and the death was not an accident. Now DI Samantha Freeman must figure out what happened—and to whom . . .\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Gillian Jackson\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0